require("@openfonts/amiri_arabic");
require("@openfonts/scheherazade_arabic");
